import { useEffect, useState } from 'react';
import { NAV_LINKS, TICKER_ITEMS } from '@/mocks/entertainment';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [tick, setTick] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setTick((v) => (v + 1) % TICKER_ITEMS.length);
    }, 3600);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* LIVE ticker strip */}
      <div className="bg-primary-600 text-background-50">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 md:px-6">
          <span className="flex h-full shrink-0 items-center gap-1.5 py-1.5 text-[11px] font-semibold tracking-widest">
            <i className="ri-flashlight-fill text-accent-400 text-sm"></i>
            LIVE
          </span>
          <div className="hidden h-8 flex-1 items-center overflow-hidden sm:flex">
            <p key={tick} className="truncate text-[12px] opacity-90">{TICKER_ITEMS[tick]}</p>
          </div>
          <span className="hidden shrink-0 items-center gap-1 text-[11px] opacity-80 md:flex">
            <i className="ri-calendar-line"></i> 9月9日 · 周三
          </span>
        </div>
      </div>

      {/* main masthead */}
      <div className={`border-b transition-colors duration-300 ${scrolled ? 'border-background-200/80 bg-background-50/95 backdrop-blur' : 'border-transparent bg-background-50'}`}>
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
          <a href="#top" className="group flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-600 text-background-50 transition-transform duration-300 group-hover:-rotate-6">
              <i className="ri-camera-3-line text-xl"></i>
            </span>
            <span className="leading-none">
              <h1 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[26px]">
                明星吃瓜<span className="text-primary-600">现场</span>
              </h1>
              <p className="mt-1 text-[11px] tracking-[0.28em] text-foreground-600">一手路透 · 生图 · 名场面</p>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 lg:flex" aria-label="栏目导航">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="rounded-full px-4 py-2 text-[15px] font-medium text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2.5">
            <a
              href="#subscribe"
              className="hidden whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              订阅吃瓜速递
            </a>
            <button
              type="button"
              aria-label="切换菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-background-200 text-foreground-900 lg:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'}></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden" aria-label="移动端导航">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-xl px-3 py-3 text-[15px] font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-700"
                >
                  {l.label}
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}